(function(){
const BP=4,BD=7;
let CR=4,DY=7;
const OV={},CH={},CI={};
function sug(item){
  if(item.wg)return Math.ceil(Math.max(0,2*CR*8-6*CR)/19);
  if(item.s==='pp')return item.b*CR*DY;
  if(item.s==='p')return item.b*CR;
  return item.b*(CR/BP)*(DY/BD);
}
function gv(k,item){return OV[k]!==undefined?OV[k]:sug(item);}
function sf(u){return(u==='g'||u==='ml')?50:0.5;}
function fm(v,u){
  if(!v&&v!==0)return'—';
  if(u==='g'&&v>=1000)return(Math.round(v/100)/10).toFixed(1).replace('.0','')+' kg';
  if(u==='ml'&&v>=1000)return(Math.round(v/100)/10).toFixed(1).replace('.0','')+' L';
  if(u==='g'||u==='ml')return Math.round(v)+' '+u;
  const r=Math.round(v*2)/2;
  return(r===Math.floor(r)?Math.round(r):r)+' '+u;
}
function fv(v,item){
  if(item.wg)return Math.ceil(v)+' Gallonen (19 L)';
  if(item.u==='Fl')return Math.round(v)+' Flaschen 1.5 L';
  return fm(v,item.u);
}
const S=[
  {c:'Frühstück',i:[
    {l:'Brot frisch',b:4,u:'Stk.',s:'none',n:'für die ersten 2 Tage'},
    {l:'Toastbrot (weiss oder integral)',b:2,u:'Packungen',s:'none',n:'ab Tag 3, hält gut'},
    {l:'Rohschinken abgepackt',b:4,u:'Packungen',s:'none'},
    {l:'Truthahnschinken abgepackt',b:4,u:'Packungen',s:'none'},
    {l:'Mortadella abgepackt',b:4,u:'Packungen',s:'none'},
    {l:'Hartkäse Kuh abgepackt',b:2,u:'Stk.',s:'none'},
    {l:'Hartkäse Schaf abgepackt',b:2,u:'Stk.',s:'none'},
    {l:'Butter',b:1,u:'Stk.',s:'none'},
    {l:'Mayonnaise',b:1,u:'Tube',s:'none'},
    {l:'Ajvar',b:1,u:'Glas',s:'none',n:'als Aufstrich & Beilage',sp:true},
    {l:'Marmelade Šipak (Hagebutte)',b:1,u:'Glas',s:'none',n:'kroatische Spezialität, wenn erhältlich',sp:true},
    {l:'Marmelade Granatapfel',b:1,u:'Glas',s:'none',n:'kroatische Spezialität, wenn erhältlich',sp:true},
    {l:'Haferflocken / Müsli',b:1000,u:'g',s:'none'},
    {l:'Müsli- & Energieriegel',b:12,u:'Stk.',s:'none',n:'für Wachen & Nachttörn'},
    {l:'Cookies',b:2,u:'Packungen',s:'none',n:'für Kalorien zwischendurch'},
  ]},
  {c:'Mittagessen & Abendessen',i:[
    {l:'Eier',b:24,u:'Stk.',s:'none',n:'4 Pkg. à 6 — Rührei, Omelette, hart gekocht'},
    {l:'Pasta',b:2000,u:'g',s:'none'},
    {l:'Risottoreis',b:500,u:'g',s:'none'},
    {l:'Passata / Tomatensauce (gr. Dose)',b:2,u:'Dosen',s:'none'},
    {l:'Dosenbohnen (grosse Dosen)',b:2,u:'Dosen',s:'none'},
    {l:'Thunfisch (grosse Dosen)',b:4,u:'Dosen',s:'none'},
    {l:'Olivenöl',b:500,u:'ml',s:'none'},
    {l:'Essig / Balsamico (kleine Flasche)',b:1,u:'Flasche',s:'none'},
    {l:'Zwiebeln & Knoblauch',b:200,u:'g',s:'none',n:'nur als Würze'},
    {l:'Gewürze & Bouillon',b:1,u:'Set',s:'none',n:'Paprika, Kümmel'},
    {l:'Salz (Streuer)',b:1,u:'Stk.',s:'none'},
    {l:'Pfeffer (Streuer)',b:1,u:'Stk.',s:'none'},
    {l:'Mehl',b:1000,u:'g',s:'none'},
    {l:'Zucker',b:100,u:'g',s:'none',n:'minimal'},
  ]},
  {c:'Snacks & Frisches',i:[
    {l:'Bananen (gemischter Reifegrad)',b:1,u:'Stk.',s:'pp',n:'1/Person/Tag, unterschiedl. reif kaufen'},
    {l:'Äpfel',b:1,u:'Stk.',s:'pp',n:'1/Person/Tag'},
    {l:'Avocado',b:4,u:'Stk.',s:'none',n:'wenn schön reif erhältlich'},
    {l:'Zitronen',b:3,u:'Stk.',s:'none',n:'für Tee & Mahlzeiten'},
    {l:'Frische Tomaten',b:1000,u:'g',s:'none'},
    {l:'Gurken',b:4,u:'Stk.',s:'none'},
    {l:'Karotten',b:1000,u:'g',s:'none'},
    {l:'Rote Peperoni',b:8,u:'Stk.',s:'none'},
    {l:'Frische Kräuter',b:2,u:'Bund',s:'none'},
    {l:'Jogurt / Quark (normal)',b:8,u:'Stk.',s:'none'},
    {l:'Jogurt / Quark (laktosefrei)',b:1,u:'Stk.',s:'p',n:'je nach Anz. Personen mit Intoleranz',w:true},
    {l:'Crackers / Reiswaffeln',b:1,u:'Packungen',s:'none'},
    {l:'Nüsse & Trockenfrüchte',b:4,u:'Packungen',s:'none'},
    {l:'Schokolade',b:4,u:'Tafeln',s:'none'},
    {l:'Fertigsuppen',b:6,u:'Stk.',s:'none',n:'Reserve für schlechtes Wetter'},
  ]},
  {c:'Getränke',i:[
    {l:'Trinkwasserflaschen 1.5 L (beschriften)',b:4,u:'Fl',s:'p',n:'4 Flaschen/Person, werden nachgefüllt'},
    {l:'Wassergallonen 19 L (Reservoir)',b:0,u:'Gal',s:'none',wg:true,n:'~2 L/Person/Tag × 8 Tage'},
    {l:'Kaffee (Pulver Kolben/Siebträger)',b:1,u:'Packungen',s:'none',n:'gute Qualität, kein Instant'},
    {l:'Teebeutel',b:1,u:'Packungen',s:'none'},
    {l:'UHT-Milch (normal)',b:2,u:'L',s:'none'},
    {l:'UHT-Milch (laktosefrei)',b:1,u:'L',s:'none',w:true},
    {l:'Bier',b:12,u:'Stk.',s:'none',n:'nur im Hafen / nach Wache'},
  ]},
  {c:'Bordküche & Sonstiges',i:[
    {l:'Frischhaltefolie / Zip-Beutel',b:1,u:'Set',s:'none'},
    {l:'Küchenpapier',b:4,u:'Rollen',s:'none'},
    {l:'Kleine Müllsäcke (WC)',b:1,u:'Packungen',s:'none',n:'für WC-Abfälle'},
    {l:'Hundesäckchen (Toilettenpapier)',b:1,u:'Set',s:'none',n:'für TP-Entsorgung auf See'},
    {l:'Toilettenpapier',b:4,u:'Rollen',s:'none'},
    {l:'Handseife biologisch abbaubar',b:2,u:'Stk.',s:'none',n:'geht direkt ins Meer — nur bio!',w:true},
    {l:'Feuchttücher (WC)',b:2,u:'Packungen',s:'none'},
  ]},
];
function render(){
  const el=document.getElementById('lagoo-list');
  if(!el)return;
  el.innerHTML='';
  let tot=0,dn=0;
  S.forEach((sec,si)=>{
    tot+=sec.i.length;
    const sd=sec.i.filter((_,ii)=>CH[si+'-'+ii]).length;
    const cis=CI[si]||[];
    tot+=cis.length;
    const csd=cis.filter(c=>c.checked).length;
    dn+=sd+csd;
    const div=document.createElement('div');
    div.className='lagoo-cl__section';
    div.innerHTML='<div class="lagoo-cl__sec-head">'+sec.c
      +'<span class="lagoo-cl__sec-done">'+(sd+csd)+'/'+(sec.i.length+cis.length)+'</span></div>'
      +'<div class="lagoo-cl__col-labels"><span class="lagoo-cl__col-l">Position</span>'
      +'<span class="lagoo-cl__col-s">Vorschlag</span><span class="lagoo-cl__col-r">Menge</span></div>';
    sec.i.forEach((item,ii)=>{
      const k=si+'-'+ii,isC=!!CH[k],isO=OV[k]!==undefined;
      const sg=sug(item),cur=gv(k,item),step=sf(item.u);
      const row=document.createElement('div');
      row.className='lagoo-cl__item';
      const nc=item.w?'warn':item.sp?'special':'';
      row.innerHTML=
        '<div class="lagoo-cl__cb'+(isC?' done':'')+'" data-key="'+k+'"></div>'
        +'<div style="flex:1" data-check="'+k+'">'
          +'<div class="lagoo-cl__item-name'+(isC?' done':'')+'">'+item.l+'</div>'
          +(item.n?'<span class="lagoo-cl__item-note '+nc+'">'+item.n+'</span>':'')
        +'</div>'
        +'<div class="lagoo-cl__qty-col">'
          +'<div class="lagoo-cl__qty-suggest">'+fv(sg,item)+'</div>'
          +'<div class="lagoo-cl__qty-block">'
            +'<button class="lagoo-cl__qty-btn" data-key="'+k+'" data-step="'+step+'" data-dir="-1">−</button>'
            +'<div class="lagoo-cl__qty-val'+(isO?' overridden':'')+'">'+fv(cur,item)+'</div>'
            +'<button class="lagoo-cl__qty-btn" data-key="'+k+'" data-step="'+step+'" data-dir="1">+</button>'
          +'</div>'
          +'<span class="lagoo-cl__reset-item'+(isO?' show':'')+'" data-key="'+k+'">zurücksetzen</span>'
        +'</div>';
      div.appendChild(row);
    });
    cis.forEach((ci,ci_idx)=>{
      const crow=document.createElement('div');
      crow.className='lagoo-cl__custom-row';
      const cbEl=document.createElement('div');
      cbEl.className='lagoo-cl__cb'+(ci.checked?' done':'');
      cbEl.addEventListener('click',()=>{ci.checked=!ci.checked;render();});
      const nameIn=document.createElement('input');
      nameIn.type='text';nameIn.placeholder='Eigener Artikel';
      nameIn.value=ci.label||'';nameIn.className='lagoo-cl__custom-name';
      if(ci.checked){nameIn.style.textDecoration='line-through';nameIn.style.opacity='.4';}
      nameIn.addEventListener('input',e=>{ci.label=e.target.value;});
      nameIn.addEventListener('click',e=>e.stopPropagation());
      const qtyIn=document.createElement('input');
      qtyIn.type='text';qtyIn.placeholder='Menge';
      qtyIn.value=ci.qty||'';qtyIn.className='lagoo-cl__custom-qty';
      qtyIn.addEventListener('input',e=>{ci.qty=e.target.value;});
      qtyIn.addEventListener('click',e=>e.stopPropagation());
      const delBtn=document.createElement('button');
      delBtn.className='lagoo-cl__del-btn';delBtn.textContent='×';
      delBtn.addEventListener('click',e=>{e.stopPropagation();CI[si].splice(ci_idx,1);render();});
      crow.appendChild(cbEl);crow.appendChild(nameIn);crow.appendChild(qtyIn);crow.appendChild(delBtn);
      div.appendChild(crow);
    });
    const addBtn=document.createElement('button');
    addBtn.className='lagoo-cl__add-btn';
    addBtn.textContent='Eigenes Item hinzufügen';
    addBtn.addEventListener('click',()=>{
      if(!CI[si])CI[si]=[];
      CI[si].push({label:'',qty:'',checked:false});
      render();
      setTimeout(()=>{
        const inputs=document.querySelectorAll('.lagoo-cl__custom-name');
        if(inputs.length)inputs[inputs.length-1].focus();
      },50);
    });
    div.appendChild(addBtn);
    el.appendChild(div);
  });
  document.getElementById('lagoo-prog').textContent=dn+' / '+tot;
  document.getElementById('lagoo-bar').style.width=tot?Math.round(dn/tot*100)+'%':'0%';
  el.querySelectorAll('.lagoo-cl__cb[data-key]').forEach(e=>{
    e.addEventListener('click',ev=>{const k=ev.currentTarget.dataset.key;CH[k]=!CH[k];render();});
  });
  el.querySelectorAll('[data-check]').forEach(e=>{
    e.addEventListener('click',ev=>{const k=ev.currentTarget.dataset.check;CH[k]=!CH[k];render();});
  });
  el.querySelectorAll('.lagoo-cl__qty-btn').forEach(btn=>{
    btn.addEventListener('click',e=>{
      e.stopPropagation();
      const k=btn.dataset.key,step=parseFloat(btn.dataset.step),dir=parseFloat(btn.dataset.dir);
      const si=parseInt(k.split('-')[0]),ii=parseInt(k.split('-')[1]);
      const item=S[si].i[ii],cur=gv(k,item);
      const next=Math.max(0,Math.round((cur+dir*step)/step)*step);
      if(Math.abs(next-sug(item))<0.01){delete OV[k];}else{OV[k]=next;}
      render();
    });
  });
  el.querySelectorAll('.lagoo-cl__reset-item').forEach(e=>{
    e.addEventListener('click',ev=>{ev.stopPropagation();delete OV[ev.currentTarget.dataset.key];render();});
  });
}
window.lagooSetGlobal=function(){
  CR=+document.getElementById('lagoo-s-crew').value;
  DY=+document.getElementById('lagoo-s-days').value;
  document.getElementById('lagoo-crew-val').textContent=CR+' Person'+(CR>1?'en':'');
  document.getElementById('lagoo-days-val').textContent=DY+' Tag'+(DY>1?'e':'');
  render();
};
window.lagooResetAll=function(){
  Object.keys(CH).forEach(k=>delete CH[k]);
  Object.keys(OV).forEach(k=>delete OV[k]);
  Object.keys(CI).forEach(k=>delete CI[k]);
  render();
};
window.lagooResetOverrides=function(){Object.keys(OV).forEach(k=>delete OV[k]);render();};
window.lagooPrint=function(){
  let rows='';
  S.forEach((sec,si)=>{
    rows+='<tr><td colspan="3" style="padding:12px 4px 3px;font-size:10px;font-weight:700;text-transform:uppercase;color:#555;border-bottom:2px solid #003b5c">'+sec.c+'</td></tr>';
    sec.i.forEach((item,ii)=>{
      const k=si+'-'+ii,isC=!!CH[k],cur=gv(k,item);
      rows+='<tr><td style="width:24px;text-align:center;padding:4px">'+(isC?'☑':'☐')+'</td>'
        +'<td style="padding:4px;font-size:12.5px'+(isC?';color:#bbb;text-decoration:line-through':'')+'">'
        +item.l+(item.n?'<br><span style="font-size:10px;color:#aaa">'+item.n+'</span>':'')+'</td>'
        +'<td style="font-size:11px;color:#555;text-align:right;padding:4px;white-space:nowrap">'+fv(cur,item)+'</td></tr>';
    });
    const cis=CI[si]||[];
    cis.forEach(ci=>{
      rows+='<tr><td style="width:24px;text-align:center;padding:4px">'+(ci.checked?'☑':'☐')+'</td>'
        +'<td style="padding:4px;font-size:12.5px">'+ci.label+'</td>'
        +'<td style="font-size:11px;color:#555;text-align:right;padding:4px">'+ci.qty+'</td></tr>';
    });
  });
  const html='<!DOCTYPE html><html><head><meta charset="utf-8"><title>Proviantliste</title>'
    +'<style>body{font-family:system-ui,sans-serif;max-width:680px;margin:2rem auto;color:#1a1a1a;padding:0 1rem;font-size:13px}'
    +'h2{font-size:18px;font-weight:700;color:#ed6c21;border-bottom:2px solid #ed6c21;padding-bottom:6px}'
    +'table{width:100%;border-collapse:collapse}td{border-bottom:0.5px solid #eee;vertical-align:top}'
    +'@media print{body{margin:1cm auto}}</style></head>'
    +'<body><h2>Proviant & Getränke — '+CR+' Personen / '+DY+' Tage</h2>'
    +'<table>'+rows+'</table></body></html>';
  var w=window.open('','_blank');
  w.document.write(html);
  w.document.close();
};
document.addEventListener('DOMContentLoaded',render);
})();